/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bitcoin': {
    width: 49,
    height: 49,
    viewBox: '0 0 49 49',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" cx="24.5" cy="24.5" r="24.5" _fill="#029EE4"/><g _fill="#FFF"><path pid="1" d="M17.459 13.322h10.098c1.95 0 3.496.533 4.641 1.598s1.717 2.46 1.717 4.182c0 1.36-.385 2.51-1.156 3.451-.77.94-1.711 1.524-2.822 1.751.793.113 1.53.442 2.21.986a5.844 5.844 0 0 1 1.615 2.04 5.76 5.76 0 0 1 .595 2.55c0 1.836-.584 3.315-1.751 4.437C31.439 35.439 29.835 36 27.795 36H17.459V13.322zm9.622 9.826c1.247 0 2.21-.34 2.89-1.02.68-.68 1.02-1.553 1.02-2.618s-.346-1.944-1.037-2.635c-.691-.691-1.649-1.037-2.873-1.037h-6.8v7.31h6.8zm.136 10.336c1.315 0 2.346-.351 3.094-1.054.748-.703 1.122-1.655 1.122-2.856 0-1.11-.368-2.04-1.105-2.788-.737-.748-1.774-1.122-3.111-1.122h-6.936v7.82h6.936z"/><path pid="2" d="M14 29h11v2H14z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/compiled-icons/bitcoin.js